export default function ExperienceSection() {
  return (
    <section id="experience" className="bg-background-50">
      <div className="relative h-[780px] md:h-[520px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Lamborghini%20Countach%2025th%20Anniversary%20edition%20white%20body%20color%20parked%20on%20a%20scenic%20Japanese%20mountain%20road%20at%20dusk%2C%20dramatic%20golden%20hour%20lighting%20with%20long%20shadows%2C%20iconic%20wedge%20shape%20silhouette%20against%20twilight%20sky%2C%20clean%20minimal%20background%20with%20distant%20mountains%2C%20cinematic%20automotive%20photography%2C%20epic%20and%20powerful%20composition%2C%20professional%20lighting%2C%20sharp%20details&width=1920&height=800&seq=countach-experience-hero&orientation=landscape"
          alt="Lamborghini Countach 25th Anniversary"
          className="w-full h-full object-cover object-top anim-slow-zoom"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60"></div>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center text-background-50 px-4 md:px-6">
          <p className="text-[9px] md:text-[10px] tracking-[0.4em] md:tracking-[0.5em] uppercase text-accent-300 mb-2 md:mb-4">&mdash; Legendary Icon &mdash;</p>
          <h2 className="font-heading text-3xl md:text-7xl leading-tight">
            Lamborghini
            <br />
            <span className="italic text-accent-300">Countach</span>
          </h2>
          <p className="mt-1 md:mt-2 text-base md:text-2xl tracking-[0.2em] md:tracking-[0.3em] uppercase text-accent-300/80 font-label">
            25th Anniversary
          </p>
          <div className="mt-3 md:mt-6 max-w-3xl text-xs md:text-sm leading-relaxed md:leading-loose text-background-50/85 space-y-2 md:space-y-3 px-2 md:px-0">
            <p>
              1974年の誕生から約16年間続いたカウンタックの生産。そのラストを飾るモデルとして<br className="hidden md:inline" />1988年に登場したのがこの25周年記念モデルです。
            </p>
            <p>
              後にパガーニ社を創設する天才デザイナー、オラチオ・パガーニの手によってリファインされた空力ボディは、歴代モデルの中で最もアグレッシブで現代的な美しさを放ちます。
            </p>
            <p>
              現在、世界中のコレクターが熱望し、その市場価値は高騰を続けています。<br className="hidden md:inline" />
              本物のV12気筒キャブレター（またはインジェクション）エンジンが奏でる咆哮と、時代を超越したスタイリング。この歴史的遺産（ヘリテージ）を実際に体感できる機会は、世界を探しても極めて限定されています。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}